export const appConstants = {
  DRAWER_APPOINTMENTS: "DRAWER_APPOINTMENTS",
  USER_ROLE: "USER_ROLE",
  REFRESH_APPOINTMENTS: "REFRESH_APPOINTMENTS",
  USER: "USER",
  ACCESS_TOKEN: "ACCESS_TOKEN",
  COMPONENT_NAME: "COMPONENT_NAME",
  COMPONENT_DATA: "COMPONENT_DATA",
  DISPLAY_CONSULTANTS_IN_DRAWER: "DISPLAY_CONSULTANTS_IN_DRAWER",
  CENTER_DETAIL: "CENTER_DETAIL",
  READ_ONLY: "READ_ONLY",
  CURRENT_CENTER: "CurrentCenter",
  NOTIFICATION: "NOTIFICATION",
  INCREMENT_COUNTER: "INCREMENT_COUNTER",
  DECREMENT_COUNTER: "DECREMENT_COUNTER",
  UPDATE_TOAST_TRUE: "UPDATE_TOAST_TRUE",
  UPDATE_TOAST_FALSE: "UPDATE_TOAST_FALSE",
  RESET: "RESET",
}
